var exports = {
  "AS": "xcc377c0b--db34da--item",
  "Pf": "xcc377c0b--db34da--label",
  "O0": "xcc377c0b--db34da--rating",
};

module.exports = exports;
